import AtomSkeleton from '@s-ui/react-atom-skeleton'
import {useSuiContext} from '@s-ui/react-context'
import AiTypingText, {aiTypingTextSpeeds} from '@adv-mt/mt-ai-typing-text'
import {AiIcon} from '@adv-mt/ui/ai-icon'
import {ICON_SIZES} from '@adv-mt/ui/icon'

const BASE_CLASS = 'mt-NetLoading'

const LoadingSkeleton = () => {
  const {i18n} = useSuiContext()

  const loadingTexts = [
    i18n.t('NET.LOADING_SKELETON.MESSAGE_01'),
    i18n.t('NET.LOADING_SKELETON.MESSAGE_02'),
    i18n.t('NET.LOADING_SKELETON.MESSAGE_03'),
    i18n.t('NET.LOADING_SKELETON.MESSAGE_04'),
    i18n.t('NET.LOADING_SKELETON.MESSAGE_05')
  ]

  return (
    <>
      <AiTypingText
        className={`${BASE_CLASS}-aiTypingText`}
        speed={aiTypingTextSpeeds.REGULAR}
        texts={loadingTexts}
        icon={<AiIcon loading size={ICON_SIZES.SM} />}
      />
      <div className={`${BASE_CLASS}--skeleton`}>
        <AtomSkeleton height={24} width={250} />
      </div>
    </>
  )
}

LoadingSkeleton.displayName = 'LoadingSkeleton'

export default LoadingSkeleton
